import React, { Component } from 'react'
import DashboardContainer from 'src/containers/DashboardContainer'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchEvent, setEventId } from 'src/actions'
import FlyerFonts from 'src/assets/frontend-json/flyer-fonts.json'
import {
  fetchMeWithCommunities,
  changeEventForm,
  fetchCreateEvent,
  fetchFlyerDesigns,
  fetchUploadFlyer,
  archiveTicketType,
  createTicketType
} from 'src/actions/event'
import { eventSelector, ticketTypesSelector } from 'src/selectors'
import LoadingScreen from 'src/components/LoadingScreen'
import EventDetailContainer from './EventDetail/EventDetailContainer'
import PreviewIcon from 'src/assets/icons/preview-icon.png'
import HobnobModal from 'src/components/common/HobnobModal'
import FlyerListContainer from 'src/containers/event/CreateEvent/SecondStep/SecondStep'
import FlyerContainerV2 from 'src/containers/event/CreateEvent/FlyerContainerV2/FlyerContainerV2'
import LoadingComponent from 'src/components/common/LoadingComponent/LoadingComponent'
import moment from 'moment-timezone'
import styles from './edit-event-container.scss'
import ImagesIcon from 'src/assets/icons/icon_images.png'

import { eventTicketInfoRequest, setTicketTypes } from 'src/actions/paymentGraphql'
import { deepCopyArray } from 'src/services/utils'
import { hobnobSetHref } from 'src/actions/utils'
import CustomFlyerPicker from 'src/components/common/CustomFlyerPicker'
import { setCustomFlyerBg } from 'src/actions/flyer'

class EditEventContainer extends Component {
  state = {
    loadingEvent: true,
    loadingEdit: false,
    isOpenFlyer: false,
    checkedFlyerNumber: null,
    child_count_enabled: false
  }

  flyerRef = null

  getEventTicket = event => {
    const { onGetEventTicket, onSetTicketTypes } = this.props

    onGetEventTicket({
      containerId: event.id,
      containerType: 'event',
      hostId: event.user_id,
      onSuccessCallback: res => {
        if (res?.data?.ticket_types_for_container) {
          let ticketTypes = deepCopyArray(res?.data.ticket_types_for_container)
          const adultTicketTypes = ticketTypes.filter(item => item.label === 'adult')
          const childTicketTypes = ticketTypes.filter(item => item.label === 'child')
          const otherTicketTypes = ticketTypes.filter(
            item => item.label !== 'adult' && item.label !== 'child'
          )
          const tempTicketTypes = adultTicketTypes.concat(childTicketTypes).concat(otherTicketTypes)
          onSetTicketTypes(tempTicketTypes)
        }
      }
    })
  }

  componentDidMount() {
    const {
      onFetchEvent,
      onSetEventId,
      onFetchCommunities,
      params: { eventToken },
      eventForm,
      onChangeEventForm,
      onGetFlyerDesigns
    } = this.props

    if (eventToken) {
      onFetchCommunities()
      onGetFlyerDesigns()
      this.onLoadFonts()
      onFetchEvent({
        eventToken,
        onSuccessCallback: async data => {
          const { event } = data
          this.getEventTicket(event)
          onSetEventId(event.id)
          const cloneData = {}
          for (let key in eventForm) {
            switch (key) {
              case 'flyer_design_number':
                cloneData[key] = String(event.flyer.design_number)
                break
              case 'flyer_design_slug':
                cloneData[key] = event.flyer.design_slug
                break
              case 'starts_at':
                cloneData[key] = event[key]
                  ? moment.tz(event.starts_at, event.timezone).format('YYYY-MM-DD HH:mm')
                  : event[key]
                break
              case 'ends_at':
                cloneData[key] = event[key]
                  ? moment.tz(event.ends_at, event.timezone).format('YYYY-MM-DD HH:mm')
                  : event[key]
                break
              default:
                cloneData[key] = event[key]
            }
          }
          onChangeEventForm({ ...cloneData })
          if (event.flyer?.image_bg_upload?.image_url) {
            const resp = await fetch(event.flyer?.image_bg_upload?.image_url)
            const imageBlob = await resp.blob()
            const reader = new FileReader()
            reader.onload = (e) => {
              this.props.setCustomFlyerBg({ bgDataURL: e.target.result })
              this.setState({
                loadingEvent: false
              })
            }
            reader.readAsDataURL(imageBlob)
            this.setState({
              checkedFlyerNumber: cloneData.flyer_design_number,
              child_count_enabled: event.child_count_enabled
            })
          } else {
            this.setState({
              loadingEvent: false,
              checkedFlyerNumber: cloneData.flyer_design_number,
              child_count_enabled: event.child_count_enabled
            })
          }
        }
      })
    }
  }

  onLoadFonts = () => {
    const fonts = FlyerFonts.fonts
    for (let font of fonts) {
      let myFonts = new FontFace(font.slice(0, -4), `url(../../../assets/Fonts/${font})`) // 这是对的
      myFonts.load().then(loadFace => {
        document.fonts.add(loadFace)
      })
    }
  }

  handleChangeFlyer = () => {
    const { eventForm } = this.props
    this.setState({ checkedFlyerNumber: eventForm.flyer_design_number, isOpenFlyer: false })
  }

  handleEditEvent = () => {
    const { eventForm, onEditEvent, event, ticketTypes, onArchiveTicketType, onCreateTicketType } =
      this.props
    const { child_count_enabled } = this.state

    this.setState({ loadingEdit: true })
    this.flyerRef.canvasToImage()

    setTimeout(() => {
      const eventParams = { ...eventForm }
      delete eventParams.checkedFlyer

      if (eventParams.starts_at) {
        eventParams.starts_at = moment.tz(eventParams.starts_at, eventParams.timezone).format()
        if (eventParams.ends_at) {
          eventParams.ends_at = moment.tz(eventParams.ends_at, eventParams.timezone).format()
        }
      }

      onEditEvent({
        eventId: event.id,
        eventForm: eventParams,
        onSuccessCallback: () => {
          if (child_count_enabled !== eventForm.child_count_enabled) {
            if (eventForm.child_count_enabled) {
              onCreateTicketType(event.id)
            } else {
              const child = ticketTypes.find(item => item.label === 'child' && !item.archived_at)
              if (child) {
                onArchiveTicketType(child.id)
              }
            }
          }
          this.handleUploadFlyer(event.id, event.url)
        }
      })
    }, 500)
  }

  handleUploadFlyer = (eventId, eventUrl) => {
    const { onUploadFlyer, eventForm, customFlyerBg } = this.props

    onUploadFlyer({
      eventId,
      design_number: eventForm.flyer_design_number,
      customBgDataURL: customFlyerBg.bgDataURL,
      onSuccessCallback: async data => {
        const requests = []
        if (data?.image_flyer?.image_upload?.presigned_url) {
          const flyerImage = await fetch(eventForm.checkedFlyer)
          const flyerImageBlob = await flyerImage.blob()
          requests.push(fetch(data.image_flyer.image_upload.presigned_url, {
            headers: {
              'Content-Type': 'image/png'
            },
            method: 'PUT',
            body: flyerImageBlob
          }))
        }

        if (data?.image_flyer?.image_bg_upload?.presigned_url) {
          const flyerBgImage = await fetch(customFlyerBg.bgDataURL)
          const flyerBgImageBlob = await flyerBgImage.blob()
          requests.push(fetch(data.image_flyer.image_bg_upload.presigned_url, {
            headers: {
              'Content-Type': 'image/png'
            },
            method: 'PUT',
            body: flyerBgImageBlob
          }))
        }

        if (requests.length === 0) {
          this.setState({ isLoading: false })
          alert('Upload Error.')
          return
        }

        Promise.all(requests).then(responses => {
          if (responses.every(response => response.status === 200)) {
            setTimeout(() => {
              hobnobSetHref(eventUrl)
            }, 3000)
          } else {
            this.setState({ loadingEdit: false })
            alert('Upload Error')
          }
        })
      }
    })
  }

  generateFlyerKey = () => {
    const {
      eventForm: { name, starts_at, custom_venue_name, ends_at }
    } = this.props

    return `${name},${starts_at},${custom_venue_name},${ends_at},${this.state.checkedFlyerNumber}`
  }

  render() {
    const { eventForm, flyerList, customFlyerBg } = this.props
    const { loadingEvent, isOpenFlyer, checkedFlyerNumber, loadingEdit } = this.state

    const selectedFlyerDetail = flyerList.find(flyer => flyer.design_number === checkedFlyerNumber)

    if (!loadingEvent) {
      return (
        <DashboardContainer>
          <div className={styles['event-container']}>
            <div className={styles['flier-container']}>
              <div className={styles['flyer-inner']}>
                {selectedFlyerDetail && (
                  <FlyerContainerV2
                    onRef={ref => (this.flyerRef = ref)}
                    flyerDetail={selectedFlyerDetail}
                    customBgDataURL={customFlyerBg.bgDataURL}
                    key={this.generateFlyerKey()}
                    type="edit"
                  />
                )}
              </div>

              <img
                onClick={() => this.setState({ isOpenFlyer: true })}
                src={PreviewIcon}
                width="54"
                className={styles['preview-icon']}
                alt={selectedFlyerDetail?.design_slug}
              />
            </div>
            <div>
              <EventDetailContainer onEdit={this.handleEditEvent} event={eventForm} />
            </div>
          </div>

          <HobnobModal
            show={isOpenFlyer}
            onClose={() => this.setState({ isOpenFlyer: false })}
            containerStyles={{ maxWidth: '90vw', height: '80vh' }}
          >
            <header className={styles['header']}>
              <div className={styles['left']} />
              <h2>Design</h2>
              <div className={styles['right']}>
                <CustomFlyerPicker>
                  <img src={ImagesIcon} width={'24px'} alt={'custom-flyer'} />
                </CustomFlyerPicker>
              </div>
            </header>
            <FlyerListContainer type="edit" onButtonClick={this.handleChangeFlyer} />
          </HobnobModal>

          {loadingEdit && <LoadingComponent />}
        </DashboardContainer>
      )
    } else {
      return <LoadingScreen />
    }
  }
}

EditEventContainer.propTypes = {
  params: PropTypes.object,
  onFetchEvent: PropTypes.func,
  event: PropTypes.object,
  onSetEventId: PropTypes.func,
  onFetchCommunities: PropTypes.func,
  eventForm: PropTypes.object,
  onChangeEventForm: PropTypes.func,
  onEditEvent: PropTypes.func,
  onGetFlyerDesigns: PropTypes.func,
  flyerList: PropTypes.array,
  onUploadFlyer: PropTypes.func,
  onGetEventTicket: PropTypes.func,
  onSetTicketTypes: PropTypes.func,
  ticketTypes: PropTypes.array,
  onArchiveTicketType: PropTypes.func,
  onCreateTicketType: PropTypes.func,
  setCustomFlyerBg: PropTypes.func,
  customFlyerBg: PropTypes.object
}

function mapDispatchToProps(dispatch) {
  return {
    onFetchEvent: params => dispatch(fetchEvent(params.eventToken, params.onSuccessCallback)),
    onSetEventId: eventId => dispatch(setEventId(eventId)),
    onFetchCommunities: () => dispatch(fetchMeWithCommunities()),
    onChangeEventForm: params => dispatch(changeEventForm(params)),
    onEditEvent: params => dispatch(fetchCreateEvent(params)),
    onGetFlyerDesigns: () => dispatch(fetchFlyerDesigns()),
    onUploadFlyer: params => dispatch(fetchUploadFlyer(params)),
    onGetEventTicket: params => dispatch(eventTicketInfoRequest(params)),
    onSetTicketTypes: params => dispatch(setTicketTypes(params)),
    onArchiveTicketType: params => dispatch(archiveTicketType(params)),
    onCreateTicketType: eventId => dispatch(createTicketType(eventId)),
    setCustomFlyerBg: (params) => dispatch(setCustomFlyerBg(params.bgDataURL))
  }
}

function mapStateToProps(state) {
  return {
    event: eventSelector(state),
    eventForm: state.frontend.eventForm,
    flyerList: state.frontend.flyerList,
    ticketTypes: ticketTypesSelector(state),
    customFlyerBg: state.frontend.customFlyerBg
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditEventContainer)



// WEBPACK FOOTER //
// ./src/containers/event/EditEvent/EditEventContainer.jsx